import request from '../../utils/request';
import { Result } from '../../models/general';
import type {
    OnboardingProcessView,
    OnboardingProcessInput,
    OnboardingProcessTaskView,
    OnboardingProcessTaskInput,
    UpdateTaskStatusInput,
    EmployeeSelectionView,
    MyBlockingStatusView,
    DashboardOnboardingTaskView,
} from '../../models/employee';

export async function getOnboardingProcesses(): Promise<Result<OnboardingProcessView[]>> {
    const response = await request.get<Result<OnboardingProcessView[]>>('OnboardingProcess/GetAll');
    return response.data;
}

export async function getOnboardingProcess(id: number): Promise<Result<OnboardingProcessView>> {
    const response = await request.get<Result<OnboardingProcessView>>(`OnboardingProcess/GetById/${id}`);
    return response.data;
}

export async function startOnboarding(input: OnboardingProcessInput): Promise<Result<OnboardingProcessView>> {
    const response = await request.post<Result<OnboardingProcessView>>('OnboardingProcess/StartOnboarding', input);
    return response.data;
}

export async function updateOnboarding(id: number, input: OnboardingProcessInput): Promise<Result<OnboardingProcessView>> {
    const response = await request.put<Result<OnboardingProcessView>>(`OnboardingProcess/UpdateOnboarding/${id}`, input);
    return response.data;
}

export async function cancelOnboarding(id: number): Promise<Result<boolean>> {
    const response = await request.post<Result<boolean>>(`OnboardingProcess/CancelOnboarding/${id}`);
    return response.data;
}

export async function deleteOnboarding(id: number): Promise<Result<boolean>> {
    const response = await request.delete<Result<boolean>>(`OnboardingProcess/DeleteOnboarding/${id}`);
    return response.data;
}

export async function updateTaskStatus(taskId: number, input: UpdateTaskStatusInput): Promise<Result<OnboardingProcessTaskView>> {
    const response = await request.put<Result<OnboardingProcessTaskView>>(`OnboardingProcess/UpdateTaskStatus/${taskId}`, input);
    return response.data;
}

export async function addTask(processId: number, input: OnboardingProcessTaskInput): Promise<Result<OnboardingProcessTaskView>> {
    const response = await request.post<Result<OnboardingProcessTaskView>>(`OnboardingProcess/AddTask/${processId}`, input);
    return response.data;
}

export async function removeTask(taskId: number): Promise<Result<boolean>> {
    const response = await request.delete<Result<boolean>>(`OnboardingProcess/RemoveTask/${taskId}`);
    return response.data;
}

export async function getEmployeeSelections(): Promise<Result<EmployeeSelectionView[]>> {
    const response = await request.get<Result<EmployeeSelectionView[]>>('OnboardingProcess/GetEmployeeSelections');
    return response.data;
}

export async function getMyBlockingStatus(): Promise<Result<MyBlockingStatusView>> {
    const response = await request.get<Result<MyBlockingStatusView>>('OnboardingProcess/MyBlockingStatus');
    return response.data;
}

export async function getMyDashboardTasks(): Promise<Result<DashboardOnboardingTaskView[]>> {
    const response = await request.get<Result<DashboardOnboardingTaskView[]>>('OnboardingProcess/MyDashboardTasks');
    return response.data;
}

export async function getManagerDashboardTasks(): Promise<Result<DashboardOnboardingTaskView[]>> {
    const response = await request.get<Result<DashboardOnboardingTaskView[]>>('OnboardingProcess/ManagerDashboardTasks');
    return response.data;
}

export async function getHrDashboardTasks(): Promise<Result<DashboardOnboardingTaskView[]>> {
    const response = await request.get<Result<DashboardOnboardingTaskView[]>>('OnboardingProcess/HrDashboardTasks');
    return response.data;
}
